import React from 'react';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import OfficeService from '../../../Services/OfficeService';
import FreelancerInvoiceContactEditItem from '../../../Domain/FreelancerInvoiceContactEditItem';

export default class EditFreelancerInvoiceContactsWindowDescription extends React.Component {
  static titleForEdit = 'Edit Vendor Invoice Contacts';
  static itemType = FreelancerInvoiceContactEditItem;
  static serviceFunction = (edited) => OfficeService.EditFreelancerInvoiceContacts(edited);

  getSelected() {}

  getSearchParameters() {}

  getAllItemInTheSearchAreSelected() {}

  static pagesInGeneralEditWizzard = [
    {
      label: 'Contacts',
      fields: [
        {
          fieldName: 'DqContacts',
          label: 'DQ Contacts',
          className: 'col-12',
          type: InputTypesEnum.ActiveUserMultiSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'RmContacts',
          label: 'RM Contacts',
          className: 'col-12',
          type: InputTypesEnum.ActiveUserMultiSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'KamContacts',
          label: 'KAM Contacts',
          className: 'col-12',
          type: InputTypesEnum.ActiveUserMultiSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'BiContacts',
          label: 'BI Contacts',
          className: 'col-12',
          type: InputTypesEnum.ActiveUserMultiSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'BdContacts',
          label: 'BD Contacts',
          className: 'col-12',
          type: InputTypesEnum.ActiveUserMultiSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'HrContacts',
          label: 'HR Contacts',
          className: 'col-12',
          type: InputTypesEnum.ActiveUserMultiSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'ItContacts',
          label: 'IT Contacts',
          className: 'col-12',
          type: InputTypesEnum.ActiveUserMultiSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'MarketingContacts',
          label: 'Marketing Contacts',
          className: 'col-12',
          type: InputTypesEnum.ActiveUserMultiSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'FinanceContacts',
          label: 'Finance Contacts',
          className: 'col-12',
          type: InputTypesEnum.ActiveUserMultiSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];
}
